import React, { useState } from 'react';
import { login } from '../../services/api';

const formatLockDuration = (lockedUntil) => {
  let remainingSeconds = Math.max(0, lockedUntil - Math.floor(Date.now() / 1000));
  const units = [
    ['day', 24 * 60 * 60],
    ['hour', 60 * 60],
    ['minute', 60],
    ['second', 1],
  ];
  const parts = [];

  for (const [label, seconds] of units) {
    const value = Math.floor(remainingSeconds / seconds);
    if (value > 0) {
      parts.push(`${value} ${label}${value === 1 ? '' : 's'}`);
      remainingSeconds %= seconds;
    }
  }

  return parts.slice(0, 2).join(' ') || 'less than a second';
};

function Login({ onLogin }) {
  const [formData, setFormData] = useState({ login: '', password: '', rememberMe: false });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(formData.login, formData.password, formData.rememberMe);
      onLogin(response.data.token, response.data.userId, response.data.isAdmin, formData.rememberMe);
    } catch (err) {
      const { error: responseError, lockedUntil } = err.response?.data || {};
      const lockMessage = lockedUntil
        ? `${responseError || 'Too many failed login attempts'}.\nTry again in ${formatLockDuration(lockedUntil)}.`
        : null;
      setError(lockMessage || responseError || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>

        {error && <div className="error" style={{ whiteSpace: 'pre-line' }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Login</label>
            <input
              type="text"
              value={formData.login}
              onChange={(e) => setFormData({ ...formData, login: e.target.value })}
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
            />
          </div>

          <div className="form-group form-group-checkbox">
            <label className="checkbox-label">
              <input
                type="checkbox"
                className="checkbox-input"
                checked={formData.rememberMe}
                onChange={(e) => setFormData({ ...formData, rememberMe: e.target.checked })}
              />
              <span>Remember me</span>
            </label>
          </div>

          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Please wait...' : 'Login'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
